import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import Modal from '../../Atoms/Modal/Modal';
import fileIcon from '../../../assets/Imagess/file-icon-green.svg';
import uploadIcon from '../../../assets/Imagess/upload-icon.svg';
import styles from '../../Atoms/Modal/Modal.module.scss';
import Buttons from '../../Atoms/Buttons/Buttons';
import closeIcon from '../../../assets/Imagess/close2.svg';
import folderIcon from '../../../assets/Imagess/folderICon.svg';
import { useMutation } from 'react-query';
import { API_URL, securityHeaders } from '../../../Constants';
import axios from 'axios';
import { useToast } from '../Custom/CustomToaster/Toast';
import TextInput from '../../Atoms/Inputs/TextInput';
import ModalChildrenContainer from '../../Atoms/Modal/ModalChildrenContainer';
import hashIcon from '../../../assets/icons/formActions/inputs/hash.svg';
import CustomSelect from '../../Atoms/forms/customSelect/CustomSelect';

const validationSchema = Yup.object().shape({
  albumNameAr: Yup.string().required('مطلوب تعبئته '),
  orderId: Yup.number()
    .typeError('الترتيب يجب أن يكون رقم')
    .integer('الترتيب يجب أن يكون رقم صحيح')
    .min(1, 'الترتيب يجب أن يكون أكبر من 0')
    .required('الترتيب مطلوب'),
  images: Yup.array()
    .min(1, 'يرجى اختيار صورة واحدة على الأقل')
    .required('يرجى اختيار صورة واحدة على الأقل'),
});

const CreateAlbumModal = ({ handleOnClose, refetch, albumsCount = 0 }) => {
  const fileInputRef = useRef(null);
  const customizedToast = useToast();
  const formikRef = useRef(null);
  const [formKey, setFormKey] = useState(0);
  const createAlbum = useMutation({
    mutationFn: (fields) =>
      axios.post(API_URL + `/api/News/MediaGallery`, fields, {
        headers: securityHeaders,
      }),
  });

  const clearAll = () => {
    formikRef.current?.resetForm({
      values: { albumNameAr: '', images: [], orderId: '' },
    });

    if (fileInputRef.current) fileInputRef.current.value = '';

    setFormKey((k) => k + 1);
  };

  const uploadImage = useMutation({
    mutationFn: (fields) =>
      axios.post(API_URL + `/api/News/MediaGalleryDetails`, fields, {
        headers: securityHeaders,
      }),
  });

  const handleUploadImageClick = () => {
    fileInputRef.current?.click();
  };

  const handleUploadImages = async (id, imagesArr) => {
    for (let i = 0; i < imagesArr.length; i++) {
      const formData = new FormData();
      formData.append('MediaGalleryId', id);
      formData.append('Image', imagesArr[i]);
      await uploadImage.mutateAsync(formData);
    }
  };
  useEffect(() => {
    refetch();
  }, []);
  const orderOptions = useMemo(() => {
    const maxOrder = Math.max(Number(albumsCount || 0) + 1, 1);
    return Array.from({ length: maxOrder }, (_, i) => {
      const n = i + 1;
      return { value: n, text: String(n) };
    });
  }, [albumsCount]);
  return (
    <Modal
      onClose={() => {
        clearAll();
        handleOnClose?.();
      }}
      width='600px'
      closeWhite={false}
      title='إنشاء ألبوم جديد'
      scrollY='auto'
    >
      <Formik
        key={formKey}
        initialValues={{ albumNameAr: '', images: [], orderId: '' }}
        innerRef={formikRef}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            const formData = new FormData();
            formData.append(
              'MediaGalleryId',
              '00000000-0000-0000-0000-000000000000'
            );
            formData.append('GalleryName_AR', values.albumNameAr);
            formData.append('OrderId', String(Number(values.orderId)));

            const res = await createAlbum.mutateAsync(formData);
            const mediaGalleryId = res?.data?.mediaGalleryId;

            await handleUploadImages(mediaGalleryId, values.images);
            clearAll();
            customizedToast.open('تم إنشاء الألبوم ورفع الصور');
            refetch?.();
            handleOnClose?.();
          } catch (error) {
            alert(error?.message);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <Form>
            <ModalChildrenContainer>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '24px',
                }}
                dir='rtl'
              >
                <Field name='albumNameAr'>
                  {() => (
                    <TextInput
                      label='اسم الالبوم'
                      placeholder='ادخل الاسم'
                      icon={folderIcon}
                      value={values.albumNameAr}
                      name='albumNameAr'
                      onChange={(name, value) => setFieldValue(name, value)}
                      errors={errors.albumNameAr}
                      touched={touched.albumNameAr}
                      left
                    />
                  )}
                </Field>
                <Field name='orderId'>
                  {() => (
                    <CustomSelect
                      label='التسلسل'
                      placeholder='اختر رقم الترتيب'
                      icon={hashIcon}
                      value={values.orderId}
                      name='orderId'
                      onChange={(name, v) => setFieldValue(name, Number(v))}
                      options={orderOptions}
                      touched={touched.orderId}
                      errors={errors.orderId}
                      type='category'
                      left
                    />
                  )}
                </Field>
                <div
                  className={styles['upload-container']}
                  onClick={handleUploadImageClick}
                >
                  <img
                    src={uploadIcon}
                    className={styles['upload-icon-modal']}
                    alt=''
                  />
                  <div className={styles['text-row']}>
                    <p className={styles['select-text']}>
                      اختر الوسائط للتحميل
                    </p>
                    <p className={styles['size-text']}>
                      الحجم الأقصى: 100 ميجابايت
                    </p>
                  </div>
                </div>

                {touched.images && errors.images ? (
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <p
                      style={{
                        marginTop: '-14px',
                        color: '#d32f2f',
                        fontSize: 12,
                      }}
                    >
                      {errors.images}
                    </p>
                  </div>
                ) : null}

                {values.images?.length > 0 &&
                  values.images.map((image, index) => (
                    <div
                      key={index}
                      className={styles['uploaded-item-container']}
                    >
                      <div className={styles['file-name-container']}>
                        <img src={fileIcon} alt='' />
                        <p className={styles['file-name']}>{image?.name}</p>
                      </div>

                      <div
                        onClick={() => {
                          const next = values.images.filter(
                            (_, i) => i !== index
                          );
                          setFieldValue('images', next);
                        }}
                        style={{ cursor: 'pointer', alignSelf: 'center' }}
                      >
                        <img src={closeIcon} alt='' />
                      </div>
                    </div>
                  ))}

                <Buttons
                  text='حفظ'
                  color='#0DA06E'
                  rounded={true}
                  style={{ width: '100%', fontFamily: 'BukraBold' }}
                  type='submit'
                />
              </div>
            </ModalChildrenContainer>

            <input
              type='file'
              accept='image/*'
              style={{ display: 'none' }}
              ref={fileInputRef}
              multiple
              onChange={(e) => {
                const files = Array.from(e.target.files || []);
                if (!files.length) return;

                setFieldValue('images', [...(values.images || []), ...files]);

                e.target.value = '';
              }}
            />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default CreateAlbumModal;
